/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Tag } from '@coursera/cds-core';

import _t from 'i18n!nls/course-sessions';

type Props = {
  selected: number;
  total: number;
};

const styles = {
  tag: css`
    padding: 0.5rem 1rem;
  `,
};

const SessionSelectionIndicator: React.FunctionComponent<Props> = ({ selected, total }) => {
  return (
    <Tag
      variant="status"
      aria-label={_t('#{selected} sessions currently selected for #{total} courses', { selected, total })}
      priority="secondary"
      color={selected === total ? 'success' : 'default'}
      css={styles.tag}
    >
      {_t('#{selected} out of #{total}', { selected, total })}
    </Tag>
  );
};

export default SessionSelectionIndicator;
